import { Prisma } from '@prisma/client';

// 회원가입 상태 정의 (상태와 API 응답 코드 통합)
export enum RegistrationStatus {
  REGISTERED = 'REGISTERED',
  NOT_ALLOWED = 'NOT_ALLOWED',
  REJECTED = 'REJECTED', // 거부된 이메일
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  NOT_SENT = 'NOT_SENT',
  WAITING = 'WAITING',
  WAITING_EXPIRED = 'WAITING_EXPIRED',
  VERIFIED = 'VERIFIED',
  VERIFIED_EXPIRED = 'VERIFIED_EXPIRED',
  INVALID_TOKEN = 'INVALID_TOKEN',
  TOKEN_EXPIRED = 'TOKEN_EXPIRED',
  ALREADY_VERIFIED = 'ALREADY_VERIFIED',
  VERIFICATION_SUCCESS = 'VERIFICATION_SUCCESS',
}

export interface RegistrationStatusRequest {
  email: string;
}

// 회원가입 상태 응답 인터페이스
export interface RegistrationStatusResponse {
  status: RegistrationStatus;
  message: string;
  data?: {
    email: string;
    allowedEmail?: Prisma.allowed_emailsGetPayload<object> | null;
    existingUser?: Prisma.usersGetPayload<object> | null;
    latestVerification?: Prisma.email_verificationGetPayload<object> | null;
    sentAt?: Date;
    expiresAt?: Date;
    verifiedAt?: Date;
  };
  redirectTo?: 'login' | 'send-verification' | 'register';
}

// 회원가입 상태 체크 결과
export interface RegistrationCheckResult {
  allowedEmail: Prisma.allowed_emailsGetPayload<object> | null;
  existingUser: Prisma.usersGetPayload<object> | null;
  latestVerification: Prisma.email_verificationGetPayload<object> | null;
}
